/**
 * 상거래 기능을 위한 한국어 복사본 카탈로그
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * 키는 기능의 React 컴포넌트에 있는 `t('commerce.*')` 호출을 반영합니다.
 * 값은 i18n 스위프 동안 추출한 정확한 한국어 문자열입니다.
 */
export const commerceKo = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': '라이브러리 청구하기',
  'commerce.dtrpg.seoDescription': 'DriveThruRPG 라이브러리를 가져오고 Grymwyrd PDF를 청구하세요.',
  'commerce.dtrpg.heading': '라이브러리 청구하기',
  'commerce.dtrpg.intro':
    'DriveThruRPG에서 Grymwyrd를 구매하셨거나 캠페인에 참여하셨나요? 구매 이메일로 로그인하여 라이브러리를 가져오고 사본을 청구하세요.',
  'commerce.dtrpg.sendLinkError': '지금은 로그인 링크를 보낼 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.dtrpg.checkInboxPrefix': '다음 주소의 수신함을 확인하세요',
  'commerce.dtrpg.checkInboxSuffix':
    '해당 이메일로 Grymwyrd를 구매하거나 후원했다면, 로그인 링크가 곧 도착합니다. 링크를 클릭하여 돌아와 라이브러리를 청구하세요.',
  'commerce.dtrpg.linkAutoSignIn': '링크는 자동으로 로그인합니다. 비밀번호가 필요 없습니다.',
  'commerce.dtrpg.purchaseEmailLabel': '구매/후원 이메일',
  'commerce.dtrpg.sendingLink': '링크를 보내는 중…',
  'commerce.dtrpg.emailLinkCta': '로그인 링크를 이메일로 보내기',
  'commerce.dtrpg.signedInAs': '로그인됨',
  'commerce.dtrpg.signOut': '로그아웃',
  'commerce.dtrpg.dtrpgEmailLabel': 'DriveThruRPG 이메일',
  'commerce.dtrpg.dtrpgEmailOptional': '(선택 — 위의 이메일과 다를 경우)',
  'commerce.dtrpg.dtrpgEmailHelp': 'DriveThruRPG 구매를 일치시켜 라이브러리를 부여할 때 사용합니다.',
  'commerce.dtrpg.libraryHeading': 'Grymwyrd 라이브러리',
  'commerce.dtrpg.noTitles': '아직 가져올 수 있는 타이틀이 설정되지 않았습니다.',
  'commerce.dtrpg.claimNotInLibrary':
    '이 타이틀은 아직 라이브러리에 없습니다. 올바른 구매 이메일을 사용했는지 확인하세요.',
  'commerce.dtrpg.claimSessionExpired': '세션이 만료되었습니다. 다시 로그인하세요.',
  'commerce.dtrpg.claimError': '지금은 이 타이틀을 청구할 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.dtrpg.preparingCopy': '사본 준비 중…',
  'commerce.dtrpg.download': '다운로드',
  'commerce.dtrpg.preparing': '준비 중…',
  'commerce.dtrpg.claiming': '청구 중…',
  'commerce.dtrpg.claim': '청구',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': '결제 페이지를 열 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.paywall.signInToPurchase': '구매를 완료하려면 로그인하세요.',
  'commerce.paywall.vaultSealed': '상인의 금고가 잠겨 있습니다. 나중에 다시 시도해주세요.',
  'commerce.paywall.signInToUnlock': '로그인하여 잠금 해제',
  'commerce.paywall.comingSoonTitle': '이 구매는 곧 출시됩니다',
  'commerce.paywall.priceComingSoon': '{price} — 곧 출시',
  'commerce.paywall.comingSoon': '곧 출시',
  'commerce.paywall.openingVault': '금고를 열 중…',
  'commerce.paywall.unlockPrice': '잠금 해제 — {price}',
  'commerce.paywall.unlock': '잠금 해제',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': '"{name}"을(를) 테이블에 설치했습니다.',
  'commerce.marketplace.installNotOwned': '이 팩을 아직 소유하지 않았습니다. 팩 구매는 곧 시작될 예정입니다.',
  'commerce.marketplace.installHostOnly': '테이블 호스트만 팩을 설치할 수 있습니다.',
  'commerce.marketplace.installError': '이 팩을 설치할 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.marketplace.installed': '설치됨',
  'commerce.marketplace.installing': '설치 중…',
  'commerce.marketplace.installOnTable': '테이블에 설치',
  'commerce.marketplace.seoTitle': '마켓플레이스 — 팩',
  'commerce.marketplace.seoDescription':
    '크리에이터 콘텐츠 팩(지도, 장면, 핸드아웃, 빠른 시작 프리셋)을 찾아보고 테이블에 설치하세요.',
  'commerce.marketplace.eyebrow': '마켓플레이스',
  'commerce.marketplace.heading': '콘텐츠 팩',
  'commerce.marketplace.intro':
    '지도, 장면, 핸드아웃, 빠른 시작 프리셋을 한 번의 클릭으로 테이블에 설치하세요.',
  'commerce.marketplace.installingOnto': '테이블 {tableId}에 설치 중입니다.',
  'commerce.marketplace.signInHeading': '팩을 보려면 로그인하세요',
  'commerce.marketplace.signInBlurb': '팩 카탈로그는 크리에이터 계정과 연결되어 있습니다.',
  'commerce.marketplace.signIn': '로그인',
  'commerce.marketplace.loading': '팩을 소환 중…',
  'commerce.marketplace.noPacksHeading': '팩 없음',
  'commerce.marketplace.noPacksBlurb':
    '게시한 팩이 없습니다. 다른 크리에이터의 팩을 찾아볼 수 있는 공개 마켓플레이스는 곧 출시됩니다.',
  'commerce.marketplace.footer': '다른 크리에이터의 팩과 유료 팩 열람은 곧 시작될 예정입니다.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': '구독자 전용 테이블',
  'commerce.subscriber.perk1Blurb': '구독자를 위해 예약한 즐겨찾는 호스트의 테이블에 참석하세요.',
  'commerce.subscriber.perk2Title': '조기 & 독점 콘텐츠',
  'commerce.subscriber.perk2Blurb': '캠페인 챕터, 장면, 핸드아웃을 다른 사람보다 먼저 받으세요.',
  'commerce.subscriber.perk3Title': '구독자 특별 표시',
  'commerce.subscriber.perk3Blurb': '프로필과 테이블에 위상의 표시가 나타납니다.',
  'commerce.subscriber.seoTitle': '구독자 혜택',
  'commerce.subscriber.seoDescription':
    '구독자가 되어 독점 테이블, 조기 콘텐츠, 구독자 특별 표시를 받으세요.',
  'commerce.subscriber.heading': '구독자 되기',
  'commerce.subscriber.intro':
    '좋아하는 호스트와 크리에이터를 지원하세요. 그들이 내부 coven을 위해 예약한 혜택을 잠금 해제하세요.',
  'commerce.subscriber.activeHeading': '구독자입니다',
  'commerce.subscriber.activeBlurb':
    '혜택이 활성화되었습니다. 참석할 수 있는 테이블에서 구독자 휘장을 찾으세요.',
  'commerce.subscriber.findTable': '구독자 테이블 찾기',
  'commerce.subscriber.paywallTitle': 'Grymwyrd 구독자',
  'commerce.subscriber.paywallBlurb':
    '구독자 전용 테이블, 조기 콘텐츠, 구독자 특별 표시를 잠금 해제하세요.',
  'commerce.subscriber.paywallPrice': '월 $5부터',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': '결제 페이지를 열 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.ticket.signInToBuy': '이 테이블에 자리를 예약하려면 로그인하세요.',
  'commerce.ticket.boxOfficeClosed': '티켓 오피스가 현재 닫혀 있습니다. 나중에 다시 시도해주세요.',
  'commerce.ticket.seoTitle': '자리 구매',
  'commerce.ticket.seoDescription': '티켓 테이블의 자리를 예약하세요.',
  'commerce.ticket.eyebrow': '티켓 테이블',
  'commerce.ticket.heading': '자리 예약',
  'commerce.ticket.loading': '테이블 로드 중…',
  'commerce.ticket.notFoundHeading': '테이블을 찾을 수 없음',
  'commerce.ticket.notFoundBlurb': '이 테이블이 종료되었거나 문이 열리지 않았을 수 있습니다.',
  'commerce.ticket.backToLobby': '로비로 돌아가기',
  'commerce.ticket.freeHeading': '이 테이블은 무료로 참석할 수 있습니다',
  'commerce.ticket.freeBlurb': '티켓이 필요 없습니다. 자리를 잡으세요.',
  'commerce.ticket.goToLobby': '로비로 가기',
  'commerce.ticket.untitledTable': '제목 없는 테이블',
  'commerce.ticket.seatPrice': '자리 가격',
  'commerce.ticket.spectatorsNote': '관전자도 이 테이블의 티켓을 소유해야 합니다.',
  'commerce.ticket.paymentReceived': '결제 완료됨. 자리가 예약되었습니다. 로비로 가서 앉으세요.',
  'commerce.ticket.signInToBuySeat': '로그인하여 자리 구매',
  'commerce.ticket.openingBoxOffice': '티켓 오피스를 열 중…',
  'commerce.ticket.buySeatPrice': '자리 구매 — {price}',
  'commerce.ticket.comingSoonTitle': '티켓팅이 곧 출시됩니다',
  'commerce.ticket.ticketingComingSoon': '티켓팅 곧 출시',
  'commerce.ticket.comingSoonFooter': '유료 자리는 곧 준비됩니다. 당분간 호스트에게 무료 초대를 요청하세요.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': '테이블 호스트만 목표를 관리할 수 있습니다.',
  'commerce.tip.errHostOnlyBounty': '테이블 호스트만 현상금을 관리할 수 있습니다.',
  'commerce.tip.errMaxGoal': '이 테이블의 최대 목표 수에 도달했습니다.',
  'commerce.tip.errMaxBounty': '이 테이블의 최대 현상금 수에 도달했습니다.',
  'commerce.tip.errMissingGoal': '해당 목표에 필수 정보가 누락되었습니다.',
  'commerce.tip.errMissingBounty': '해당 현상금에 필수 정보가 누락되었습니다.',
  'commerce.tip.errSignIn': '호스트로 로그인하여 이 테이블을 관리하세요.',
  'commerce.tip.errSaveFailedGoal': '목표를 저장할 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.tip.errSaveFailedBounty': '현상금을 저장할 수 없습니다. 나중에 다시 시도해주세요.',
  'commerce.tip.goalValidation': '라벨과 양의 달러 목표를 추가하세요.',
  'commerce.tip.goalAdded': '목표 "{label}"이(가) 추가되었습니다.',
  'commerce.tip.goalLabelPlaceholder': '목표 라벨(예: 보스 소환)',
  'commerce.tip.targetPlaceholder': '목표 $',
  'commerce.tip.cuePlaceholder': '도달 시 신호(예: 팡파르)',
  'commerce.tip.addGoal': '목표 추가',
  'commerce.tip.bountyValidation': '라벨, 양의 목표, 트리거를 추가하세요.',
  'commerce.tip.bountyAdded': '현상금 "{label}"이(가) 추가되었습니다.',
  'commerce.tip.bountyLabelPlaceholder': '현상금 라벨(예: 자연 20 판정은 파티를 구한다)',
  'commerce.tip.triggerPlaceholder': '트리거(예: 자연 20)',
  'commerce.tip.addBounty': '현상금 추가',
  'commerce.tip.signInToManage': '로그인하여 이 테이블을 관리하세요.',
  'commerce.tip.bountyClaimed': '현상금 "{label}"이(가) 요청되었습니다.',
  'commerce.tip.seoTitle': '팁 목표 & 현상금',
  'commerce.tip.seoDescription': '테이블의 팁 목표와 현상금을 설정하세요.',
  'commerce.tip.backToLobby': '로비로 돌아가기',
  'commerce.tip.heading': '팁 목표 & 현상금',
  'commerce.tip.intro':
    '테이블의 목표와 현상금을 설정하세요. 팁이 쌓이면 신호가 울립니다. 스트림 표시는 방송 오버레이에서 처리합니다.',
  'commerce.tip.loading': '원장을 읽는 중…',
  'commerce.tip.loadErrorTitle': '원장을 로드할 수 없습니다',
  'commerce.tip.raisedSoFar': '지금까지 모금된 금액:',
  'commerce.tip.tipGoalsHeading': '팁 목표',
  'commerce.tip.noGoals': '아직 목표가 없습니다. 아래에서 첫 번째를 추가하세요.',
  'commerce.tip.reachedAria': '도달',
  'commerce.tip.bountiesHeading': '현상금',
  'commerce.tip.noBounties': '아직 현상금이 없습니다. 아래에서 첫 번째를 추가하세요.',
  'commerce.tip.whenLabel': '· 트리거: {trigger}',
  'commerce.tip.claimed': '요청됨',
  'commerce.tip.claimTitleReady': '이 현상금을 요청함으로 표시',
  'commerce.tip.claimTitleNotFunded': '아직 펀딩되지 않음',
  'commerce.tip.claim': '요청',
} as const
